angular.module("imgautoModule", []).directive('imgauto', function() {
    return {
        restrict: 'A',
        scope: {
            imgshow: "="
        },
        link: function(scope, elem, iAttrs) {
            scope.$watch("imgshow", function(newV, oldV) {
                if (newV != undefined) {
                    var _w = parseInt(elem.width()); //获取td的宽度
                    elem.find("img").each(function(i) {
                        var img = $(this);
                        var realWidth;
                        var realHeight;
                        var newimg = new Image();
                        newimg.src = $(img).attr("src");
                        newimg.onload = function() {
                            realWidth = this.width;
                            realHeight = this.height;
                            //如果真实的宽度大于td的宽度就按照100%显示
                            if (realWidth >= _w) {
                                $(img).css("width", "100%").css("height", "auto");
                            } else { //如果小于td的宽度按照原尺寸显示
                                $(img).css("width", realWidth + 'px').css("height", realHeight + 'px');
                            }
                        };
                    });
                }
            });
            // $timeout(function() {
            //     var eleWidth = ele.width(),
            //         img = ele.find("img"),
            //         imgwidth = img.width();
            //     if (imgwidth > eleWidth) {
            //         img.css("width", "100%");
            //     } else {
            //         img.css("width", "auto");
            //     }
            // }, 1000);
        }
    };
});